class StickyProductForm extends window.BAO.CustomElement() {
  connectedCallback () {
    this.state = {
      currentStep: 0,
      maxSteps: this.els.step.elements.length,
      steps: this.els.step.elements,
    }

    this.steps = this.els.step.elements

    this.triggerView = document.querySelector(
      '[data-sticky-product-form-external-el="triggerView"]',
    )

    this.setupEventListeners()
    this.setupVariantChangeListener()
    this.setupPreorderWatcher()

    this.updateVariantAvailability()
  }

  setupEventListeners () {
    this.triggerView.addEventListener(
      'click',
      this.handleTriggerViewClick.bind(this),
    )

    this.addEventListener('click', e => {
      const trigger = e.target.closest(
        '[data-sticky-product-form-el="variantTrigger"]',
      )
      if (trigger) {
        this.handleVariantTriggerClick(e)
      }
    })

    this.els.editButton.element.addEventListener(
      'click',
      this.handleEditButtonClick.bind(this),
    )

    window.addEventListener(
      'reset-sticky-product-form',
      this.resetForm.bind(this),
    )

    this.els.backButton.elements.forEach(backButton => {
      backButton.addEventListener(
        'click',
        this.handleBackButtonClick.bind(this),
      )
    })
  }

  handleTriggerViewClick () {
    this.removeAttribute('hidden')
    document.querySelector(
      '[data-sticky-product-form-external-el="strapline"]',
    ).hidden = true
    document.querySelector(
      '[data-sticky-product-form-external-el="triggerView"]',
    ).hidden = true

    document.body.style.setProperty('--FixedBar_Height', '120px')
  }

  handleEditButtonClick () {
    this.resetForm()
  }

  resetForm () {
    this.setAttribute('hidden', '')
    document.querySelector(
      '[data-sticky-product-form-external-el="strapline"]',
    ).hidden = false
    document.querySelector(
      '[data-sticky-product-form-external-el="triggerView"]',
    ).hidden = false
    this.els.step.elements.forEach(step => {
      step.hidden = true
    })
    this.els.addToCart.element.setAttribute('hidden', '')
    this.els.step.elements[0].hidden = false
    this.state.currentStep = 0
    document.body.style.setProperty('--FixedBar_Height', '54px')
  }

  handleVariantTriggerClick (e) {
    const trigger = e.target.closest(
      '[data-sticky-product-form-el="variantTrigger"]',
    )
    if (!trigger) return

    const optionIndex = trigger.dataset.index
    const optionValue = trigger.dataset.value

    const allTriggers = document.querySelectorAll(
      `[data-index="${optionIndex}"]`,
    )
    allTriggers.forEach(triggerEl => {
      if (triggerEl.tagName === 'SELECT') {
        triggerEl.value = optionValue
        triggerEl.dispatchEvent(new Event('change', { bubbles: true }))
      } else if (triggerEl.hasAttribute('data-product-options-el')) {
        triggerEl.setAttribute(
          'aria-pressed',
          (triggerEl.dataset.value === optionValue).toString(),
        )
      }
    })

    const stickyTriggers = this.querySelectorAll(
      `[data-index="${optionIndex}"]`,
    )
    stickyTriggers.forEach(triggerEl => {
      if (triggerEl.tagName === 'SELECT') {
        triggerEl.value = optionValue
      } else {
        triggerEl.setAttribute(
          'aria-pressed',
          (triggerEl.dataset.value === optionValue).toString(),
        )
      }
    })

    this.updateVariantTitle()
    this.updateVariantAvailability()

    if (this.state.currentStep < this.state.maxSteps - 1) {
      this.state.currentStep = this.state.currentStep + 1
      this.moveToNextStep()
    } else {
      this.moveToAddToCart()
    }
  }

  handleBackButtonClick () {
    this.state.currentStep = this.state.currentStep - 1
    this.moveToPreviousStep()
  }

  moveToPreviousStep () {
    const lastStep = this.state.steps[this.state.currentStep]
    const nextStep = this.state.steps[this.state.currentStep + 1]
    lastStep.hidden = false
    nextStep.hidden = true
  }

  moveToNextStep () {
    if (this.state.currentStep === this.state.maxSteps) return

    const lastStep = this.state.steps[this.state.currentStep - 1]
    const nextStep = this.state.steps[this.state.currentStep]

    lastStep.hidden = true
    nextStep.hidden = false
  }

  moveToAddToCart () {
    this.els.addToCart.element.removeAttribute('hidden')
    this.els.step.elements.forEach(step => {
      step.hidden = true
    })
  }

  setupVariantChangeListener () {
    this.updateVariantTitle()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.VARIANT_CHANGED,
      this.handleMainFormVariantChange.bind(this),
    )
  }

  setupPreorderWatcher () {
    const mainProductForm = document.querySelector('form[data-product-form]')
    if (!mainProductForm) return

    this.preorderObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          this.handlePreorderClassChange(mainProductForm)
        }
      })
    })

    this.preorderObserver.observe(mainProductForm, {
      attributes: true,
      attributeFilter: ['class'],
    })

    this.handlePreorderClassChange(mainProductForm)
  }

  handlePreorderClassChange (mainProductForm) {
    const isPreorder = mainProductForm.classList.contains(
      'x-pd-atc-form--preorder',
    )
    this.updateButtonTextForPreorder(isPreorder)
  }

  updateButtonTextForPreorder (isPreorder) {
    const addToCartText = this.els.addToCart.element.querySelector(
      '[data-sticky-product-form-add-to-cart-text]',
    )

    if (!addToCartText) return

    if (isPreorder) {
      addToCartText.textContent = window.variantStrings?.preOrder || 'Pre Order'
    } else {
      const variantSelects = this.querySelector('variant-selects')
      const variant = variantSelects?.currentVariant

      if (variant && variant.available) {
        addToCartText.textContent =
          window.variantStrings?.addToCart || 'Add to Cart'
      } else {
        addToCartText.textContent = window.variantStrings?.soldOut || 'Sold Out'
      }
    }
  }

  handleMainFormVariantChange (event) {
    if (
      !event.detail.triggeredBy ||
      event.detail.triggeredBy.target.closest('sticky-product-form')
    ) {
      return
    }

    this.syncWithMainForm(event.detail.variant)
  }

  syncWithMainForm (variant) {
    this.updateButtonAvailability(variant)

    const mainVariantSelects = document.querySelector(
      'variant-selects:not(sticky-product-form variant-selects)',
    )
    if (!mainVariantSelects) return

    const mainSelectedOptions = []
    mainVariantSelects
      .querySelectorAll(
        '[data-product-options-el="trigger"][aria-pressed="true"]',
      )
      .forEach(button => {
        mainSelectedOptions.push({
          index: button.dataset.index,
          value: button.dataset.value,
        })
      })

    mainSelectedOptions.forEach(option => {
      const stickyButtons = this.querySelectorAll(
        `[data-index="${option.index}"]`,
      )
      stickyButtons.forEach(button => {
        if (button.dataset.value === option.value) {
          button.setAttribute('aria-pressed', 'true')
        } else {
          button.setAttribute('aria-pressed', 'false')
        }
      })
    })

    this.updateVariantTitle()

    this.updateVariantAvailability(variant)
  }

  updateVariantAvailability (variantOverride = null) {
    const variantSelects = this.querySelector('variant-selects')
    if (variantSelects && variantSelects.setOptionStates) {
      variantSelects.setOptionStates()

      const variant = variantOverride || variantSelects.currentVariant
      this.updateButtonAvailability(variant)
    }
  }

  updateButtonAvailability (variant) {
    const addToCartButton = this.els.addToCart.element.querySelector(
      '[data-sticky-product-form-add-to-cart]',
    )
    const backInStockButton = this.els.addToCart.element.querySelector(
      '[data-sticky-product-form-back-in-stock]',
    )
    const addToCartText = this.els.addToCart.element.querySelector(
      '[data-sticky-product-form-add-to-cart-text]',
    )
    const addToCartContainer = this.els.addToCart.element

    const mainProductForm = document.querySelector('form[data-product-form]')
    const isPreorder = mainProductForm?.classList.contains(
      'x-pd-atc-form--preorder',
    )

    if (variant && variant.available) {
      addToCartButton.disabled = false
      addToCartButton.removeAttribute('hidden')
      backInStockButton.setAttribute('hidden', '')
      addToCartContainer.setAttribute('data-current-variant-available', 'true')

      if (addToCartText) {
        if (isPreorder) {
          addToCartText.textContent =
            window.variantStrings?.preOrder || 'Pre Order'
        } else {
          addToCartText.textContent =
            window.variantStrings?.addToCart || 'Add to Cart'
        }
      }
    } else {
      addToCartButton.disabled = true
      addToCartButton.setAttribute('hidden', '')
      backInStockButton.removeAttribute('hidden')
      addToCartContainer.setAttribute('data-current-variant-available', 'false')

      if (addToCartText) {
        addToCartText.textContent = window.variantStrings?.soldOut || 'Sold Out'
      }

      if (variant) {
        backInStockButton.setAttribute('data-variant-id', variant.id)
      }
    }

    const variantIdInput = this.querySelector('input[name="id"]')
    if (variantIdInput && variant) {
      variantIdInput.value = variant.id
    }
  }

  updateVariantTitle () {
    if (!this.els.variantTitle?.element) return

    const selectedOptions = []

    this.els.step.elements.forEach(step => {
      const selectedButton = step.querySelector('[aria-pressed="true"]')
      if (selectedButton) {
        selectedOptions.push(selectedButton.dataset.value)
      }
    })

    if (selectedOptions.length > 0) {
      const formattedTitle = `Size ${selectedOptions.join(' / ')}`
      this.els.variantTitle.element.textContent = formattedTitle
    }
  }

  disconnectedCallback () {
    if (this.preorderObserver) {
      this.preorderObserver.disconnect()
    }
  }
}

customElements.define('sticky-product-form', StickyProductForm)
